/*
 * THREE r184 公共 shim — space-sdk-plugin CDN 插件共享
 * [r184 compat] ES5 语法，兼容 buble 打包链
 */
/* eslint-env browser */
/* global zqcore */

var LOG_PREFIX = '[three-shim-r184]';

var THREE = (typeof window !== 'undefined' && window.THREE) ? window.THREE : null;

if (!THREE && typeof qspace !== 'undefined' && qspace.THREE) {
  THREE = qspace.THREE;
}

if (!THREE) {
  console.error(LOG_PREFIX + ' THREE is not available! Load THREE.js before the plugin.');
  THREE = {};
}

if (THREE && !THREE.__r184ShimInitialized) {
  THREE.__r184ShimInitialized = true;

  if (!THREE.__compatInit) {
    THREE.__compatInit = function (self, BaseCtor, args) {
      args = args || [];
      if (!BaseCtor) {
        console.warn(LOG_PREFIX + ' __compatInit: BaseCtor is undefined');
        return;
      }
      var defaults = _getDefaultArgsFor(BaseCtor);
      var tmp = null;
      try {
        tmp = new (Function.prototype.bind.apply(BaseCtor, [null].concat(args.length ? args : defaults)));
      } catch (e1) {
        try {
          tmp = new BaseCtor();
        } catch (e2) {
          console.warn(LOG_PREFIX + ' __compatInit failed', BaseCtor.name || BaseCtor);
        }
      }
      if (tmp) _copyOwnProps(self, tmp);
    };
  }

  if (!THREE.Math && THREE.MathUtils) {
    THREE.Math = THREE.MathUtils;
  }

  var geoAliases = [
    'Box', 'Circle', 'Cone', 'Cylinder', 'Dodecahedron', 'Extrude',
    'Icosahedron', 'Lathe', 'Octahedron', 'Plane', 'Ring', 'Shape',
    'Sphere', 'Tetrahedron', 'Torus', 'TorusKnot', 'Tube'
  ];
  geoAliases.forEach(function (name) {
    var bufferName = name + 'BufferGeometry';
    var geoName = name + 'Geometry';
    if (!THREE[bufferName] && THREE[geoName]) {
      THREE[bufferName] = THREE[geoName];
    }
  });

  if (typeof THREE.LinearEncoding === 'undefined') {
    THREE.LinearEncoding = 3000;
  }
  if (typeof THREE.sRGBEncoding === 'undefined') {
    THREE.sRGBEncoding = 3001;
  }

  if (THREE.Matrix4 && THREE.Matrix4.prototype && !THREE.Matrix4.prototype.getInverse) {
    THREE.Matrix4.prototype.getInverse = function (matrix) {
      return this.copy(matrix).invert();
    };
  }

  if (THREE.ShaderChunk) {
    if (!THREE.ShaderChunk.encodings_fragment && THREE.ShaderChunk.colorspace_fragment) {
      THREE.ShaderChunk.encodings_fragment = THREE.ShaderChunk.colorspace_fragment;
    }
    if (!THREE.ShaderChunk.encodings_pars_fragment && THREE.ShaderChunk.colorspace_pars_fragment) {
      THREE.ShaderChunk.encodings_pars_fragment = THREE.ShaderChunk.colorspace_pars_fragment;
    }
  }

  _injectExtendedThreeFromQspace(THREE);
  _applyLoaderSyncFromQspace(THREE);
  _applyMathClassesFromQspace(THREE);
  _applyMathUtilsFromQspace(THREE);
  _mirrorExtendedThreeToQspace(THREE);
}

function _mirrorExtendedThreeToQspace(THREE) {
  if (!THREE || typeof qspace === 'undefined' || !qspace.THREE || qspace.THREE === THREE) return;
  var keys = [
    'Line2', 'LineGeometry', 'LineMaterial', 'LineSegments2', 'LineSegmentsGeometry',
    'CSS2DObject', 'CSS2DRenderer', 'CSS3DObject', 'CSS3DSprite', 'CSS3DRenderer',
  ];
  keys.forEach(function (key) {
    if (THREE[key] && typeof THREE[key] === 'function' && (!qspace.THREE[key] || typeof qspace.THREE[key] !== 'function')) {
      qspace.THREE[key] = THREE[key];
    }
    if (qspace.THREE[key] && typeof qspace.THREE[key] === 'function' && (!THREE[key] || typeof THREE[key] !== 'function')) {
      THREE[key] = qspace.THREE[key];
    }
  });
}

function _applyMathUtilsFromQspace(THREE) {
  if (!THREE) return;
  var sources = [];
  if (typeof qspace !== 'undefined' && qspace.THREE) {
    sources.push(qspace.THREE);
  }
  if (typeof window !== 'undefined' && window.THREE) {
    sources.push(window.THREE);
  }
  var mathUtils = null;
  for (var i = 0; i < sources.length; i++) {
    var src = sources[i];
    if (src && src.MathUtils && typeof src.MathUtils.degToRad === 'function') {
      mathUtils = src.MathUtils;
      break;
    }
  }
  if (!mathUtils) return;
  THREE.MathUtils = mathUtils;
  THREE.Math = mathUtils;
  if (typeof qspace !== 'undefined' && qspace.THREE && qspace.THREE !== THREE) {
    qspace.THREE.MathUtils = mathUtils;
    qspace.THREE.Math = mathUtils;
  }
}

function _applyMathClassesFromQspace(THREE) {
  if (!THREE) return;
  var mathKeys = ['Vector2', 'Vector3', 'Matrix4', 'Quaternion', 'Color'];
  var sources = [];
  if (typeof qspace !== 'undefined' && qspace.THREE) {
    sources.push(qspace.THREE);
  }
  if (typeof window !== 'undefined' && window.THREE) {
    sources.push(window.THREE);
  }
  mathKeys.forEach(function (key) {
    for (var i = 0; i < sources.length; i++) {
      var src = sources[i];
      if (src && typeof src[key] === 'function') {
        THREE[key] = src[key];
        break;
      }
    }
  });
}

function _applyLoaderSyncFromQspace(THREE) {
  if (!THREE) return;
  if (typeof THREE.RGBFormat === 'undefined') {
    THREE.RGBFormat = 1003;
  }
  if (typeof THREE.RGBAFormat === 'undefined') {
    THREE.RGBAFormat = 1023;
  }
  if (typeof THREE.TriangleFanDrawMode === 'undefined') {
    THREE.TriangleFanDrawMode = 0;
  }
  if (typeof THREE.TriangleStripDrawMode === 'undefined') {
    THREE.TriangleStripDrawMode = 1;
  }

  var qTHREE = (typeof qspace !== 'undefined' && qspace.THREE) ? qspace.THREE : {};
  var keysToSync = [
    'Interpolant', 'Loader', 'Object3D', 'Material', 'BufferGeometry', 'Mesh', 'Group',
    'Sprite', 'Vector3', 'Vector2', 'Color', 'Matrix4', 'Camera',
    'QuaternionKeyframeTrack', 'NumberKeyframeTrack', 'VectorKeyframeTrack',
    'AnimationClip', 'PropertyBinding', 'LoaderUtils', 'FileLoader', 'TextureLoader',
    'ImageBitmapLoader', 'LinearFilter', 'LinearMipmapLinearFilter', 'LinearMipmapNearestFilter',
    'NearestFilter', 'NearestMipmapLinearFilter', 'NearestMipmapNearestFilter',
    'ClampToEdgeWrapping', 'RepeatWrapping', 'MirroredRepeatWrapping',
    'DoubleSide', 'FrontSide', 'TangentSpaceNormalMap', 'Box3', 'Sphere', 'MathUtils',
    'BufferAttribute', 'InterleavedBuffer', 'InterleavedBufferAttribute',
    'InterpolateDiscrete', 'InterpolateLinear', 'LineBasicMaterial', 'LineLoop', 'LineSegments',
    'Points', 'PointsMaterial', 'Skeleton', 'SkinnedMesh', 'Bone', 'CanvasTexture',
    'DirectionalLight', 'PointLight', 'SpotLight', 'OrthographicCamera', 'PerspectiveCamera',
    'Line', 'MeshStandardMaterial', 'Raycaster', 'UnsignedShortType', 'ColorManagement',
    'MeshBasicMaterial', 'MeshPhysicalMaterial', 'RGBAFormat',
  ];
  keysToSync.forEach(function (key) {
    if (qTHREE[key] && !THREE[key]) THREE[key] = qTHREE[key];
  });
  if (!THREE.TextureLoader && typeof window !== 'undefined' && window.THREE && window.THREE.TextureLoader) {
    THREE.TextureLoader = window.THREE.TextureLoader;
  }
}

function _injectExtendedThreeFromQspace(target) {
  var sources = [];
  if (typeof zqcore !== 'undefined' && zqcore.THREE) {
    sources.push(zqcore.THREE);
  }
  if (typeof qspace !== 'undefined' && qspace.THREE) {
    sources.push(qspace.THREE);
  }
  if (typeof window !== 'undefined' && window.THREE) {
    sources.push(window.THREE);
  }
  if (!sources.length) return;
  var keys = [
    'Line2', 'LineGeometry', 'LineMaterial', 'LineSegments2', 'LineSegmentsGeometry',
    'CSS2DObject', 'CSS2DRenderer', 'CSS3DObject', 'CSS3DSprite', 'CSS3DRenderer',
    'BoxBufferGeometry', 'PlaneBufferGeometry', 'SphereBufferGeometry',
    'CylinderBufferGeometry', 'ConeBufferGeometry', 'CircleBufferGeometry', 'RingBufferGeometry',
  ];
  keys.forEach(function (key) {
    for (var si = 0; si < sources.length; si++) {
      var qTHREE = sources[si];
      if (qTHREE[key] && typeof qTHREE[key] === 'function') {
        if (!target[key] || typeof target[key] !== 'function') {
          target[key] = qTHREE[key];
        }
        break;
      }
    }
  });
}

function _copyOwnProps(target, source) {
  var keys = Object.getOwnPropertyNames(source);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key === 'constructor') continue;
    var desc = Object.getOwnPropertyDescriptor(source, key);
    try {
      Object.defineProperty(target, key, desc);
    } catch (_) {}
  }
}

function _getDefaultArgsFor(BaseCtor) {
  if (!BaseCtor || !THREE) return [];
  try {
    var name = BaseCtor.name || '';
    switch (name) {
      case 'OrthographicCamera': return [-1, 1, 1, -1, 0.1, 2000];
      case 'PerspectiveCamera': return [];
      case 'Mesh': return [new THREE.BufferGeometry(), new THREE.MeshBasicMaterial()];
      case 'Line': return [new THREE.BufferGeometry(), new THREE.LineBasicMaterial()];
      case 'LineSegments': return [new THREE.BufferGeometry(), new THREE.LineBasicMaterial()];
      case 'Line2': return [];
      case 'Object3D': return [];
      case 'Group': return [];
      case 'Sprite': return [];
      case 'Loader': return [];
      case 'RawShaderMaterial': return [];
      case 'ShaderMaterial': return [];
      case 'MeshBasicMaterial': return [];
      case 'MeshLambertMaterial': return [];
      case 'InstancedBufferGeometry': return [];
      case 'LineSegmentsGeometry': return [];
      case 'LineGeometry': return [];
      default: return [];
    }
  } catch (_) {}
  return [];
}

if (typeof module === 'object' && module.exports) {
  module.exports = THREE;
}
